import { render, staticRenderFns } from "./TalentDeletePhotoModal.vue?vue&type=template&id=9126dcc4"
import script from "./TalentDeletePhotoModal.vue?vue&type=script&lang=js"
export * from "./TalentDeletePhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports